/***
 * module naming rule
 * @Description TW language
 * example [level 1 route]_[level 2 route]_...
 */
export default {
    "common": {
        "submit": "提交",
        "defaultInput": "請輸入",
        "cancel": "取消",
        "confirm": "確認",
        "loginTimeout": "未登錄或者登錄超時，請重新登錄",
        "noData": "沒有資料",
        "custom": "在線客服",
    },
    "member_account": {
        "balance": "餘額",
        "recharge": "充值",
        "flowHistory": "流量歷史",
        "purchaseRecord": "購買記錄",
        "myData": "我的流量",
        "deviceManagement": "設備管理",
        "changePsd": "修改密碼",
        "logout": "登出",
        "acBalance": "我的餘額",
        "acFlow": "我的流量",
        "acDevice": "我的設備",
        "acOrder": "購買記錄",
        "acDeviceOrder":"設備訂單",
        "acFlowStatistics": "流量統計",
        "acSetting": "設置",
        "balanceInfo": "當前餘額",
        "rechargeCode": "充值碼",
        "enterRechargeCode": "請輸入充值碼",
        "gift": "贈送",
        "returnAccount": "退款至【我的餘額】",
        "certification": "已認證",
        "noCertified": "未認證"
    },
    "modify_information": {
        "account": "帳戶",
        "name": "姓名",
        "identification": "護照/身份證號碼",
        "countryName": "常駐地區",
        "id": "身份証資料",
        "edit": "編輯",
        "complete": "完成",
        "placeholderFirstName": "請輸入您的姓氏",
        "placeholderName": "請輸入您的名字",
        "firstName": "姓氏",
        "lastName": "名字",
        "placeholderID": "請輸入您的身份證/VISA卡/駕駛號碼",
        "isNull": "未填寫",
        "onlyNumber": "只能輸入數位或字母",
        "IDTip": "只能輸入數位或字母"
    },
    "member_modifyPassword": {
        "oldPsd": "舊密碼",
        "newPsd": "新密碼",
        "title": "修改密碼",
        "submit": "修改密碼",
        "setUp": "設定",
        "accountSetUp": "帳戶設定",
        "accountManage": "帳戶管理",
        "password": "密碼",
        "forgetPassword": "忘記密碼",
        "loginOut": "登出",
        "unsubscribe": "刪除帳戶",
        "unsubscribeAfter": "刪除帳戶後，您將放棄以下權利",
        "tip1": "通過活動贈送、代充值及充值碼兌換的餘額",
        "tip2": "未用完及贈送的流量套餐",
        "tip3": "刪除帳戶前，請認真閱讀",
        "ucloudlink": "《uCloudlink帳戶註銷須知》",
        "cancellation": "聯繫客服註銷帳戶",
        "oldPsdNull": "舊密碼不能為空",
        "newPsdNull": "新密碼不能為空",
        "modifyPasswordSuccess": "修改密碼成功"
    },
    "member_myDeviceOrder": {
        "title": "設備訂單",
        "dicObj": {
            "finished": "已完成",
            "unpaid": "未付款",
            "cancel": "取消訂單"
        },
        "pending":"Pending Payment",
        "noData": "暫無設備訂單，請到商店看看~",
        "noList": "沒有數據~",
        "tryAgainLater": "請稍後再試",
    },
    "member_recharge": {
        "recharge": "充值",
        "rechargeAmount": "（選擇充值金額）",
        "present": "贈送",
        "currentBalance": "當前餘額",
        "payAmount": "充值金額",
        "unit": "￥",
        "pay": "確認支付",
        "alipay": "支付寶",
        "paypal": "PayPal",
        "operateMess": "操作提示",
        "giveMore": "贈送"
    },
    "member_equipmentManagement": {
        "noData": "沒有設備？",
        "knowMore": "了解更多",
        "bindDevice": "綁定設備",
        "placeholderIMEI": "請輸入設備IMEI號",
        "placeholderPwd": "請輸入設備初始密碼",
        "bindNow": "立即綁定",
        "myEquipment": "我的設備",
        "equipmentMunual": "設備手冊",
        "dataBound": "解除綁定",
        "bindSuccess": "綁定成功",
        "unBindSuccess": "解綁成功",
        "imeiNull": "設備IMEI不能為空",
        "pwdNull": "設備初始PWD不能為空"
    },
    "member_flowRecords": {
        "record": "流量歷史",
        "filter": "篩選",
        "trafficStatistics": "流量統計"
    },
    "member_balanceDetails": {
        "title": "購買記錄",
        "filter": "篩選",
        "total": "合計",
        "dicObj": {
            "finished": "已完成",
            "unpaid": "未付款",
            "cancel": "取消訂單"
        }
    },
    "member_productBalanceDetails": {
        "remain": "剩餘可用流量",
        "validTime": "有效期",
        "coverage": "覆蓋範圍",
        "productIntro": "套餐描述",
        "buyTime": "購買時間",
        "unsubscribe": "退訂",
        "buyTimeTips": "以上時間基於中國北京時間（GMT+8）",
        "unsubscribeTips": "退訂成功，本次消費金額將退到[我的餘額]裡"
    },
    "users_login": {
        "loginPhone": "手機登錄",
        "loginEmail": "郵箱登錄",
        "register": "帳號註冊",
        "inputPhone": "請輸入手機號碼",
        "inputPassword": "請輸入密碼",
        "forgetPassword": "忘記密碼",
        "login": "登錄",
        "goToLogin": "去登陸",
        "inputEmail": "請輸入郵箱號",
        "smsCode": "短信驗證碼",
        "inputSMSCode": "請輸入短信驗證碼",
        "noReceiveCode": "沒收到驗證碼？",
        "resend": "重新發送",
        "nextStep": "下一步",
        "findByPhone": "通過手機找回",
        "findByEmail": "通過郵箱找回",
        "verifyByEmail": "請到郵箱驗證",
        "sendEmailTo": "我們已發送一封電子郵件到",
        "findYourPassword": "請點擊其中的連結，並按步驟操作來找回您的密碼",
        "noReceiveEmail": "收不到郵件？請檢查您的垃圾郵件和已刪除郵件目錄下是否有來自 glocalme@ucloudlink.com 的郵件。",
        "or": "或",
        "resetPassword": "重設密碼",
        "oldFormat": "至少6個字元",
        "passwordFormat": "6-20個字元(字母、數位或符號的組合)",
        "completeLogin": "完成並登錄",
        "resetPasswordSuc": "重設密碼成功",
        "backToGlocalMe": "請回到 GlocalMe Connect 登錄體驗",
        "activeReminder": "帳戶未啟動，請前往該郵箱，點擊啟動連結來完成您的帳戶註冊。",
        "known": "知道了"
    },
    "users_register": {
        "registerPhone": "手機註冊",
        "registerEmail": "郵箱註冊",
        "hasAccount": "已有帳號？",
        "agree": "我同意",
        "agreement": "使用者協定",
        "and": "和",
        "policy": "隱私政策",
        "logoutNotice": "永久刪除帳戶",
        "submit": "提交",
        "selectArea": "選擇常住地區",
        "countryOrRegion": "國家/地區",
        "change": "更換",
        "defaultRegion": "中國內地",
        "AE": "阿拉伯聯合酋長國",
        "search": "搜索熱門國家/地區",
        "reminder": "溫馨提示",
        "reminderTips": "選擇【",
        "reminderTips2": "】作為常駐地區，可享受該地區及周邊的專享優惠。選定後將不可更改。確定選擇嗎？",
        "confirm": "確定",
        "cancel": "取消",
        "setPassword": "設置密碼",
        "registerByEmail": "請點擊其中的連結來完成您的帳戶註冊。",
        "activeSuc": "啟動成功",
        "activeing": "正在激活",
        "activeAgain": "再次激活",
        "activeFail": "激活失敗",
        "verified": "我已驗證",
        "registerSuccess": "註冊成功"
    },
    "home": {
        "globalPackageCN": "全球暢享套餐",
        "globalPackageEN": "ENJOY THE BEST MOBILE DATA SERVICE EXPERIENCE YOU EVER HAVE",
        "userExperienceCN": "全球過百個合作伙伴",
        "userExperienceEN": "TOGETHER WE BUILD A BETTER USER EXPERIENCE",
        "loading": "",
        "update": "由於系統服務升級，您需要選擇常住國家或地區後方可繼續使用。",
        "reminderTips": "選擇【",
        "reminderTips2": "】作為常住地，可享受我們即將為該地及周邊推出的專享優惠；且帳戶餘額將",
        "reminderTips3": "按匯率【",
        "reminderTips4": "】",
        "reminderTips5": "轉換為【",
        "reminderTips6": "】顯示。選定後將不可更改。確定選擇嗎？",
        "gotoPC":"電腦版"
    },
    "privacyPolicy" : {
        "changeDate" : "私隱條款變更公告",
        "changeContain" : "我們的私隱條款已於2018年7月更新。",
        "changeContain2" : "我們非常重視您的私隱。因此我們制定了涵蓋如可收集、使用、披露、轉讓及儲存閣下信息的私隱政策。我們不會向任何第三方提供您的信息，除非已得到您的授權。若我們需要將信息用於未經授權之用途或目的，我們會事再次征求您的同意。",
        "changeContain3" : "您可以閱讀完整的<a href=\"/users/agreement\" target=\"_blank\">《用戶協議》</a>和<a href=\"/users/privacy_policy\" target=\"_blank\">《私隱條款》</a>了解我們的承諾。",
        "noagree" : "不同意",
        "agree" : "同意",
    },
    "service": {
        "selectDevice": "選擇設備",
        "company": "企業方案",
        "faqs": "常見問題",
        "afterSale": "售後政策",
        "manual": "操作手冊",
        "safety": "安全措施",
        "coverage": "覆蓋區域"
    },
    "purchase": {
        "buy": "購買",
        "online": "網上商店",
        "offline": "線下門店",
        "distributor": "分銷商",
        "shopAddress": "店鋪地址",
        "shopTels": "聯繫電話"
    },
    "data_package": {
        "flowShop": "流量商店",
        "recommend": "為您推薦",
        "destination": "選擇目的地",
        "searchDestination": "搜索目的地",
        "historySearch": "歷史搜索",
        "clean": "清空",
        "more": "更多",
        "enjoyPackage": "暢享套餐",
        "commonPackage": "定量套餐",
        "include": "含",
        "areaPackage": "的跨區域套餐",
        "enjoyDay": "日暢享",
        "enjoyMonth": "月暢享",
        "unlimited": "無限",
        "houxiansu": "後限速",
        "currentMonth": "當月失效",
        "currentDay": "當日失效",
        "immediately": "立即生效",
        "morrow": "次日生效",
        "nextMonth": "次月生效",
        "iDay": "天",
        "iDays": "天",
        "iMonth": "個月",
        "iMonths": "個月",
        "cxtcIMonth": "月",
        "antarctica": "熱門",
        "asia": "亞洲",
        "european": "歐洲",
        "africa": "非洲",
        "northAmerica": "美洲",
        "southAmerica": "南美洲",
        "oceania": "大洋洲",
        "flow": "流量",
        "period": "有效期",
        "applicableArea": "適用區域",
        "useNotice": "使用須知",
        "cost": "需付金額",
        "order": "訂購",
        "confirmPay": "確認支付",
        "infiniteFlow": "無限流量",
        "unsubscribe": "不可退訂",
        "subscribe": "可退訂",
        "payFailed": "支付失敗",
        "paypalTips": "由於PayPal的認證機制，PayPal付款的資訊可能會出現延遲"
    },
    "pay_result": {
        "orderSuccess": "訂購成功",
        "chargeSuccess": "充值成功",
        "orderSucTips": "您購買的[ ",
        "orderSucTips2": " ]將在1分鐘內到賬，如長時間未到賬，請諮詢客服。",
        "orderSucTips3": "將在1分鐘內傳入您的帳戶，如長時間仍未入賬，請諮詢客服。",
        "packageName": "套餐名稱",
        "chargeAmount": "充值金額",
        "payAmount": "支付金額",
        "back": "返回首頁",
        "myFlow": "查看我的流量",
        "myBalance": "查看我的餘額",
        "tryLater": "請稍後再試",
        "succeed": "完成支付",
        "fail": "未能支付，請重新下單",
        "backToShop": "回到商城首頁",
        "successful": "交易成功",
        "rejected": "交易被拒絕，請聯繫您的銀行",
        "unsuccessful": "交易失敗，請重試",
        "referenceNumber": "訂單編號",
    },
    "my_order": {
        "month": "月",
        "day": "日"
    },
    "member_myFlow": {
        "myFlow": "我的流量",
        "remainHighSpeedTraffic": "剩餘高速",
        "validityPeriod": "有效期",
        "day": "天",
        "month": "月",
        "status": "狀態",
        "invalidPackage": "失效套餐",
        "usageRule": "使用規則",
        "close": "收起",
        "queryInvalidPackage": "查看失效套餐",
        "mccList": "適用區域",
        "usageMess": "使用須知",
        "payAmount": "支付金額",
        "payTime": "購買時間",
        "effectiveTime": "有效時間",
        "validTime": "生效時間",
        "invalidTime": "失效時間",
        "flow": "流量",
        "remainingFlow": "剩餘流量",
        "highSpeedTraffic": "高速流量",
        "remainHighSpeedTraffics": "剩餘高速流量",
        "unsubscribe": "退訂",
        "unsubscribed": "已退訂",
        "isCancelPackage": "是否退訂此套餐?",
        "actionTip1": "注：使用PayPal支付的訂單會收取",
        "actionTip2": " 手續費用",
        "reBack": "退款至【我的餘額】",
        "cancel": "取消",
        "cancelSuccess": "退訂成功",
        "reBackBy": "退款已退至【我的餘額】",
        "iKnow": "我知道了",
        "usageRule1": "暢享套餐優先使用",
        "usageRule2": "相同類型可用流量套餐預設按購買時間順序使用",
        "usageRule3": "若暢享套餐高速流量用完，將自動切換普通套餐使用",
        "packageUsageRule": "套餐使用規則",
        "dicObj": {
            "notActivated": "未啟動",
            "inUsing": "使用中",
            "useEnd": "已用完",
            "expire": "到期",
            "transfer": "已轉移",
            "unsubscribe": "退訂",
            "valid": "有效",
            "invalid": "無效",
            "currentMonth": "當月失效"
        },
        "to": " 至",
        "noData": "暫無流量套餐，立即前往流量商店",
        "noList": "沒有資料",
        "accumulatedThisHour": "本小時累積",
        "accumulatedThisDay": "本日累積",
        "accumulatedThisMonth": "本月累積",
        "accumulatedThisYear": "本年累積",
        "accumulatedFlow": "累積流量",
        "flowDetail": "流量詳情"
    },
    "select_area": {
        "destination": "選擇目的地",
        "selectCountry": "選擇熱門國家/地區"
    },
    "footer": {
        "belongs": "您的帳號屬於",
        "comeTo": "您已經來到",
        "site": "站",
        "changeTips": "您的帳號無法切換至其他站點",
        "changeTips2": "如需切換，請退出登錄",
        "switchWebsite": "您現在訪問其他站點與您賬號歸屬站點不一致，需要註銷登錄才能繼續訪問"
    },
    "cloud_sim": {
        "s1": {
            "content0": "GlocalMe® Inside 是 uCloudlink 創新推出的全球數據流量服務，透過內置於手機的 GlocalMe Connect 流動應用程式，用戶即可享受由 CloudSIM 技術所帶來的全新數據連接體驗。",
            "title1": "簡單易用",
            "content1": "服務覆蓋全球，開機即可上網，商務人士可以簡單無憂地享用移動數據",
            "title2": "智能選網",
            "content2": "GlocalMe® Inside的智能選網功能可實時監測信號變化，自動連接當地最優網絡。",
            "title3": "本地資費",
            "content3": "與超過140個國家及地區建立運營商合作夥伴關係，為用戶帶來公平的本地數據資費。",
            "title4": "信息安全",
            "content4": "相對公共Wi-Fi，GlocalMe® Inside為用戶提供了高效的安全與私隱保護。",
            "title5": "GlocalMe® Inside世界手機一機在手，通行全球",
        },
        "u2":{
            "title": "輕薄之選",
            "title1_1": "一機在手 全球通行",
            "title1_2": "GlocalMe U2",
            "title2": "讓流動網絡更輕型",
            "title3_1": "香檳金",
            "title3_2": "寒鐵灰",
            "title4": "時尚輕薄 易於攜帶",
            "title5": "隨時隨地 享服4G網絡",
            "title6": "基本規格",
            "title7_1": "全球覆蓋 網絡隨身",
            "title7_2": "GlocalMe「零漫游」全球流動網絡服務覆蓋5大洲100多個國家及地區",
            "title7_3": "全球網絡隨時隨地，任意連網。",
        },
        "g3":{
            "title1_1":"長效續航「零漫遊」隨身Wi-Fi",
            "title1_2": "旗艦級GlocalMe G3",
            "title2_1": "出國必備的旅遊伴侶",
            "title3_1": "黑 x 寒鐵灰邊框",
            "title3_2": "白 x 香檳金邊框",
            "title4_1": "覆蓋更廣 網絡連接更自由",
            "title4_2": "服務環跨歐、美、亞、非及大洋等5大洲，超過100多個國家及地區",
            "title4_3": "無需插入SIM卡，隨時隨地連接網絡",
            "title4_4": "詳情參閱「覆蓋區域」",
            "title5_1": "電力充沛 為您充電",
            "title5_2":"電量亦可輸出，為手機等小型電子設備充電",
            "title5_3":"5350mAh鋰離子電池，可持續使用長達15小時",
            "title5_4":"",
            "title6_1": "「零漫遊」暢享全球最佳本地網絡",
            "title6_2": "以自主研發的雲SIM技術，實時偵測和轉換最優網絡",
            "title7_1": "共享快樂",
            "title7_2": "5人分享，5機連線；設備不限於手機、手提或平板電腦等智能設備",
            "title8_1": "專屬APP 二站式全面掌握",
            "title8_2": "隨時隨地網上充值、購買流量，並查核用量記錄及管理設備，支付方式：包括信用卡、Paypal、銀聯、微信支付、支付寶等",
            "title8_3": "掃碼下載，GlocalMe手機應用程式",
            "title9_1": "資費彈性 無需合約",
            "title9_2": "流量套餐",
            "title9_3":"多元化選擇，由地區、有效期至流量限額，滿足您的各種需求",
            "title9_4":"Pay-As-You-Go:",
            "title9_5":"計費USD0.05/MB，12美元封頂，限速不限流量，詳見流量商店",
            "title9_6":"專屬地點 安全可靠",
            "title9_7":"採用Wi-Fi加密機制，加強網絡保安",
            "title9_8":"防止掉入免費Wi-Fi的黑洞",
        },
        "p3": {
            "title1_1": "多彩生活，一定有一個屬於你的顏色",
            "title1_2": "創新與和諧並重的設計，源自對產品形狀，材質與顏色的同步研發，各元素之間彼此呼應，一同創造出類拔萃，意義非凡的智慧手機",
            "title3": "通過CloudSIM技術實現，不再需要漫遊和SIM卡。",
            "title4": "你和他們之間的距離只差\"我\"",
            "title5_1": "GlocalMe® Inside",
            "title5_2": "創新的全球數據流量服務，通過內置的GlocalMe® Connect APP，用戶即可享受由CloudSIM技術帶來的前所未有的資料連接體驗",
            "title6_1": "等等，還有更多！",
            "title6_2": "我們服務包括",
        },
        "simbox": {
            "title": "SIMBOX",
            "title1": "手機秒變多卡多待",
            "title2": "15大優勢滿足多卡管理需求",
            "title3": "讓手機秒變多卡多待",
            "title4": "國際通話 零漫遊費",
            "title5": "真4G，全網通",
            "title6_1": "7x24小時線上",
            "title6_2": "電話/短信不漏接",
            "title7": "方正精緻，簡約時尚",
        },
        "glocalme_wifi": {
            "title": "為什麼選擇GlocalMe Wi-Fi",
        },
        "glocalme_phone": {
            "title": "為什麼選擇GlocalMe世界機",
        }
    },
    "about": {
        "contact": "聯繫我們",
        "news": "新聞動態",
        "glocalme": "關於我們",
        "partnership": "尋求合作",
        "partnerships": "合作夥伴",
        "note": "為了讓我們更了解您的合作意向，請填以下表格，我們會盡快與閣下聯繫！",
        "username": "姓名",
        "email": "電郵",
        "company": "公司名稱",
        "position": "職位",
        "phone": "電話",
        "demand": "詳情",
        "success": "成功",
        "deviceType": "產品類型",
        "quantity": "產品數量",
        "address": "地址",
        "heard": "從哪個途徑認識我們？",
        "agreement": "同意<a href=\"/users/privacy_policy\">《隱私政策》</a>和<a href=\"/users/agreement\">《用戶協議》</a>，uCloudlink 將會透過電郵或電話號碼與您聯繫"
    },
    "validate": {
        "isEmail": "電郵格式",
        "isMobilePhone": "手機號碼",
        "isChinaName": "中文姓名",
        "required": "必填",
        "format": "格式不正確",
        "min": "最少需要輸入",
        "max": "最多可以輸入",
        "char": "個字元",
        "equal": "輸入不一致",
        "invalid": "您的輸入含有非法字元，如 <>, >< 等",
        "digits" : "產品數量 5-100",
    },
	"newCreate": {
        "onlyForAE": "此設備僅限常駐地為阿聯酋的用戶使用",
        "purchaseTips": "此頁面只提供英文內容"
    }
}



// WEBPACK FOOTER //
// ./src/lang/tw.js